import { createSelector } from 'reselect';

import { dataUnitDataListTransitionSwapColumnsOrder } from '../../domain/unitDataList/dataUnitDataListTransitionColumnsSwappedData';
import { DataUnitDataListTransitionResponse } from '../../domain/unitDataList/types';

import { unitDataListTransitionColumnsOrderSelector } from '../ui/unitDataListReportsSetting';
import { dataUnitDataListTransitionHeatmappedSelector } from './dataUnitDataListTransition';

export const dataColumnsSwappedSelector = createSelector(
  [
    dataUnitDataListTransitionHeatmappedSelector,
    unitDataListTransitionColumnsOrderSelector,
  ],
  (
    responseData,
    columnsOrder
  ): DataUnitDataListTransitionResponse | undefined => {
    if (responseData == null) {
      return responseData;
    }

    const swappedFieldsOrder = dataUnitDataListTransitionSwapColumnsOrder(
      responseData,
      columnsOrder
    );

    return swappedFieldsOrder;
  }
);
